(function () {
  'use strict';

  function safeGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* storage unavailable */ }
  }

  /* Sticky header shadow */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile drawer */
  var drawer = document.querySelector('[data-drawer]');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); }
    else if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });

  /* Lead popup */
  var popup = document.querySelector('[data-popup]');
  var POPUP_KEY = 'tk_popup_dismissed_at';
  function popupRecentlyDismissed() {
    var days = popup ? parseInt(popup.getAttribute('data-popup-days') || '7', 10) : 7;
    var at = parseInt(safeGet(POPUP_KEY) || '0', 10);
    return at && (Date.now() - at) < days * 86400000;
  }
  function openPopup() {
    if (!popup || popup.classList.contains('is-open') || popupRecentlyDismissed()) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
  }
  function closePopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    safeSet(POPUP_KEY, String(Date.now()));
  }
  if (popup && !popupRecentlyDismissed() && !/book-a-consultation|contact/.test(window.location.pathname)) {
    var delay = parseInt(popup.getAttribute('data-popup-delay') || '25', 10) * 1000;
    setTimeout(openPopup, delay);
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && window.innerWidth > 860) openPopup();
    });
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) { e.preventDefault(); closePopup(); }
      if (e.target.closest('[data-popup-cta]')) { safeSet(POPUP_KEY, String(Date.now())); }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    if (popup && popup.classList.contains('is-open')) closePopup();
  });

  /* Scroll reveal */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Pre-select service in forms from ?service= */
  var params = new URLSearchParams(window.location.search);
  var svc = params.get('service');
  if (svc) {
    document.querySelectorAll('select[data-service-select]').forEach(function (sel) {
      Array.prototype.forEach.call(sel.options, function (opt) {
        if (opt.value.toLowerCase() === svc.toLowerCase()) sel.value = opt.value;
      });
    });
  }

  /* Lazy YouTube embed */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-youtube-id]');
    if (!trigger) return;
    e.preventDefault();
    var id = trigger.getAttribute('data-youtube-id');
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.title = trigger.getAttribute('aria-label') || 'YouTube video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    trigger.replaceWith(iframe);
  });
})();
